const { generateQueryString } = require('../../../common/base/report/report-util');

export const queryStringCalc = ({
  reportConfig,
  criteria,
  token,
  devSetting,
  criteriaStats,
}) => {
  const params = [];

  if (reportConfig.filters.ShowasOfDate && criteria.asOfDate) {
    params.push(`asOfDate=${criteria.asOfDate}`);
  }

  if (reportConfig.filters.showgroupCode && criteria.groupCode) {
    params.push(`groupCode=${criteria.groupCode}`);
  }
  if (reportConfig.filters.showisPrint && criteria.isPrintClose) {
    params.push(`isPrintClose=${criteria.isPrintClose}`);
  }

  if (reportConfig.filters.showInvestmentType && criteria.investmentType) {
    params.push(`investmentType=${criteria.investmentType}`);
  }

  if (reportConfig.filters.showInvestmentFund && criteria.fundList) {
    params.push(`fundList=${criteria.fundList}`);
  }

  if (reportConfig.filters.showmaturitydate && criteria.sortByMaturityDate) {
    params.push(`sortByMaturityDate=${criteria.sortByMaturityDate}`);
  }
  if (reportConfig.filters.showcombinedCDandCDAR && criteria.combinedSubtotalCDandCDARS) {
    params.push(`combinedSubtotalCDandCDARS=${criteria.combinedSubtotalCDandCDARS}`);
  }
  if (reportConfig.filters.showDescriptionOptions && criteria.printAllDescriptions) {
    params.push(`printAllDescriptions=${criteria.printAllDescriptions}`);
  } else if (reportConfig.filters.showDescriptionOptions && criteria.includeDescription) {
    params.push(`includeDescription=${criteria.includeDescription}`);
  }
  if (token) {
    params.push(`token=${token}`);
  }

  /* criteria stats */
  params.push(`allInvestmentType=${criteriaStats.allInvestmentType}`);
  params.push(`allFunds=${criteriaStats.allFunds}`);
  /* For testcafe */
  if (devSetting && devSetting.isTestEnvironment) {
    params.push('isTestCafe=1');
  }

  return generateQueryString(params);
};

export const reportListInvest = () => {
  const list = [
    {
      description: 'Investment Report',
      config: {
        route: 'gl/investments/investmentReport',
        filters: {
          ShowasOfDate: true,
          showgroupCode: true,
          showisPrint: true,
          showmaturitydate: true,
          showDescriptionOptions: true,
        },
      },
    },
    {
      description: 'Investment Report By Type',
      config: {
        route: 'gl/investments/investmentReportByType',
        filters: {
          ShowasOfDate: true,
          showgroupCode: false,
          showisPrint: false,
          showInvestmentType: true,
          showmaturitydate: true,
          showcombinedCDandCDAR: true,
        },
      },
    },
    {
      description: 'Investment Report By Fund',
      config: {
        route: 'gl/investments/investmentReportByFund',
        filters: {
          ShowasOfDate: true,
          showgroupCode: false,
          showisPrint: false,
          showInvestmentFund: true,
          showmaturitydate: true,
        },
      },
    },
  ];
  return list;
};

export default {
  reportListInvest,
  queryStringCalc,
};
